import { IReadme } from '_/common/types/readme.types';
import { IFlow } from '_/features/flows/common/types/flow.types';
import { IFlowSegment } from '_/features/flows/common/types/flowSegments.types';
import { setFlowType } from '_/features/flows/common/utils/flowUtils';
import { IProject } from '_/types/projects/project.types';
import { formatHours } from '_/utils/formatUtils';

import { IFlowPageData } from './flowPage.types';

export const flowPageDataAdapter = ({
  flow,
  project = flow.project,
  readme = flow.readme,
  segments,
}: {
  flow: IFlow;
  project?: IProject;
  readme?: IReadme | null;
  segments: IFlowSegment[];
}): IFlowPageData => ({
  ...flow,
  closeHours: formatHours(flow.closeHours),
  dataHours: formatHours(flow.dataHours),
  project: project,
  pushHours: formatHours(flow.pushHours),
  readme: readme,
  readmeContent: readme?.content || '',
  segments: segments,
  type: setFlowType(flow),
});
